
function toggleSummaryBullets() {
    var bullets = document.querySelector('.ProductMeta__SummaryBullets'),
        button = document.querySelector('.ProductMeta__ReadMore');
    
    if (bullets) {
        if (bullets.querySelectorAll('li').length > 3) {
            var moreText = button.innerText,
                lessText = button.dataset.lessText;
    
            button.addEventListener('click', function() {
                this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true' );
                this.innerText = this.getAttribute('aria-expanded') === 'true' ? lessText : moreText;
                bullets.classList.toggle('ProductMeta__SummaryBullets--all');
            });
        } else {
            button.style.display = 'none';
        }
    }
}

function toggleVariantThumbnails() {
    document.addEventListener('variant:changed', function(event) {

        let variant = event.detail.variant;
        let navScroller = document.getElementsByClassName('Product__SlideshowNav--thumbnails')[0];
        let flktyNav = new Flickity('.Product__SlideshowNav--thumbnails')

        navScroller.classList.add('is-hidden');
        flktyNav.deactivate();

        if (variant) {
            let sku = variant.sku.toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-image-variant="'+ sku +'"]').length,
                thumbsMobile = document.querySelectorAll('.Product__SlideshowMobileNav .flickity-page-dots .dot');

            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if (sku === thumb.dataset.imageVariant.toLowerCase()) {
                        thumb.classList.remove('hidden-tablet-and-up');
                    } else {
                        thumb.classList.add('hidden-tablet-and-up');
                    }
                });
                thumbsMobile.forEach( function(thumb) {
                    if (sku === thumb.dataset.imageVariant.toLowerCase()) {
                        thumb.classList.remove('hidden-phone');
                    } else {
                        thumb.classList.add('hidden-phone');
                    }
                });
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
                thumbsMobile.forEach( function(thumb) {
                    thumb.classList.remove('hidden-phone');
                });
            }
        }

        flktyNav.activate();
        setTimeout(function () {
                navScroller.classList.remove('is-hidden');
        }, 750);
    });
}


function toggleVariantDots(selectedColor) {
    const productSlideshow = Flickity.data('.Product__Slideshow');
    if (productSlideshow) {
        var thumbs = document.querySelectorAll('.Product__SlideshowNavImage');
        var dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot');
        thumbs.forEach( function(thumb,i) {
            dots[i].dataset.color = thumb.dataset.imageVariant.toLowerCase();
            if(selectedColor === thumb.dataset.imageVariant.toLowerCase()) {
                dots[i].classList.remove('hidden-phone','hidden-tablet', 'hidden-lap');
            } else {
                dots[i].classList.add('hidden-phone','hidden-tablet', 'hidden-lap');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    toggleSummaryBullets();
    toggleVariantThumbnails();
});